@if (displayOverflow) {
  <div class="footer-overflow"></div>
}
<div class="footer-background">
  <div class="footer-container">
    <div class="login-footer">
      <div class="desktop-content">
        <div class="logo-container">
          <svg-icon src="assets/logo/logo-white.svg" [svgStyle]="{ 'width.px':280 }"></svg-icon>
        </div>
        <div class="logo-desc logo-desc--footer">
          {{ 'login.underLogoDescription' | translate }}
        </div>
      </div>

      <div class="desktop-footer-layout">

        <div class="description" routerLink="/login">
          {{ 'login.footerInfoRow1' | translate }}
        </div>

        <div class="description mt-4">
          {{ 'login.footerInfoRow2' | translate }}
        </div>

        <div class="contacts">
          <div class="contact">
            <div class="footer-icon-container">
              <svg-icon src="assets/icons/phone.svg" [svgStyle]="{ 'width.px': 18 }" class="footer-icon"></svg-icon>
            </div>
            <a class="contacts-label"  href="tel:{{ 'footer.phoneNumber' | translate }}">
              {{ 'footer.phoneNumber' | translate }}
            </a>
            <div class="footer-text">
              {{ 'footer.hours1' | translate }}
            </div>
            <div class="footer-text">
              {{ 'footer.hours2' | translate }}
            </div>
          </div>
          <div class="contact">
            <div class="footer-icon-container footer-icon-container--responsive">
              <svg-icon src="assets/icons/envelope.svg" [svgStyle]="{ 'width.px': 19 }" class="footer-icon footer-icon--responsive"></svg-icon>
            </div>
            <a class="contacts-label" href="mailto:{{ 'footer.email' | translate }}">
              {{ 'footer.email' | translate }}
            </a>
          </div>
        </div>
      </div>

      <div class="footer-logos">
        <svg-icon src="assets/logo/moneco-logo-big-white.svg" [svgStyle]="{ 'width.px':82 }"></svg-icon>
        <svg-icon src="assets/logo/broker-consulting-logo-big.svg" [svgStyle]="{ 'width.px':80 }"></svg-icon>
      </div>

      @if (isNativePhone) {
        <a class="copyright-text phone-content" routerLink="/cookie-text">
          {{ 'login.cookieConsentLink' | translate }}
        </a>
      }

      <div class="copyright-text phone-content">
        &#169; {{ currentYear }} {{ 'login.copyright' | translate }}
      </div>

    </div>
    <div class="copyright-text desktop-content">
      &#169; {{ currentYear }} {{ 'login.copyright' | translate }}
    </div>

    @if (isNativePhone && appVersion) {
      <div class="native-version">
        {{ appVersion }}
      </div>
    }

    <div
      class="cookies-update"
      (click)="reopenCookieModal()"
      (keydown.space)="reopenCookieModal()"
      (keydown.enter)="reopenCookieModal()"
      tabindex="0"
      >
      {{ 'footer.links.cookiesUpdate' | translate }}
    </div>
  </div>
</div>